import { Card, Table, TableBody, TableCell, TableHead, TableRow, Dialog, DialogContent, DialogTitle, IconButton, TextField, Tooltip, Modal, } from '@material-ui/core';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import Pagination from "material-ui-flat-pagination";
import moment from 'moment';
import React, { Component } from 'react';
import { greentick, redcross, shareLinkIcon } from "../../../../assets/images";
import './PaymentDetails.scss';
import { toast } from 'react-toastify';
import axios from 'axios';
import { BaseUrl, ImageBaseUrl } from '../../../../Environment';
import { getSecureItem } from '../../../../utilsFunctions';
import { EditOutlined, Undo } from '@material-ui/icons';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import PaymentProcess from '../../../modals/PaymentProcess/PaymentProcess';
import { fetchAPIData } from '../../../../service/service';

const TOAST_OPTS = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: true,
};

/**
 * The four loans-table columns the "Update Base Loan Details" dialog writes.
 * Keys must match the column names editLoanBaseDetails allow-lists on the API.
 */
const BASE_FIELD_DEFS = [
  { key: "loanAmount", label: "Loan Amount Sanctioned", type: "number" },
  { key: "totalAmountToCollect", label: "Total Repayable Amount", type: "number" },
  { key: "startDate", label: "Loan Start Date", type: "date" },
  { key: "tenure", label: "Tenure", type: "number" },
];

const EMPTY_BASE_FORM = {
  loanAmount: "",
  totalAmountToCollect: "",
  startDate: "",
  tenure: "",
};

const dialogButtonBase = {
  cursor: "pointer",
  padding: "10px 16px",
  fontSize: "14px",
  borderRadius: "5px",
  fontFamily: "Lato",
  border: "none",
};

const primaryDialogButton = {
  ...dialogButtonBase,
  background: "#00d95e",
  color: "#fff",
};

const secondaryDialogButton = {
  ...dialogButtonBase,
  background: "#4d66f0",
  color: "#fff",
};

const plainDialogButton = {
  ...dialogButtonBase,
  background: "white",
  border: "1px solid lightgray",
  color: "#000",
};

class PaymentDetails extends Component {

  constructor(props) {
    super(props);
    this.hasShownChoiceModal = false;
    this.lastPartialShownFor = null;
    this.state = {
      notPaidCollection: null,
      showCollectionChoiceModal: false,
      choiceModalType: "notPaid",
      updatePreviousCollection: false,
      accessToken: "",
      receivePaymentType: "",
      isPayProcessOpen: false,
      paymentAction: null,
      isEditing: false,
      changes: {},
      tentureType: '',
      loanHistoryDetailList: [],
      isLoanActive: true,
      cancellationReason: '',
      isInstallmentCalculator: false,
      isFlexiEMI: false,
      collectionMethod: false,
      showRevert: false,
      originalData: [],
      modalOpen: false,
      modalMessage: "",
      hasShownModalForField: {}, // 🆕 keep track of shown fields
      printModalOpen: false,
      selectedRecord: null,
      selectedIndex: null,
      customerName:'',
      companyName:'',
      companyAddressCity: '',
      companyAddressFlatNo: '',
      companyAddressLandmark: '',
      companyAddressLine: '',
      companyAddressPincode: '',
      companyAddressState: '',
      companyAddressStreet: '',
      companyPhone: '',
      collaterals:{},
      // ---- pencil → "what do you want to update?" flow ----
      editChoiceOpen: false,
      baseDialogOpen: false,
      baseForm: { ...EMPTY_BASE_FORM },
      baseOriginal: { ...EMPTY_BASE_FORM },
      baseErrors: {},
      baseSaving: false,
      baseRecalculate: true,
    };
  }

  openRevert = () => {
    this.setState({showRevert: true});
  }

  /**
   * The loan id isn't passed in directly, so take it from the collection rows
   * (every row carries loanId) and fall back to the personal card.
   */
  getLoanId = () => {
    const { loanHistoryDetailList } = this.state;
    return (
      loanHistoryDetailList?.[0]?.loanId ??
      this.props.personalCardDetail?.personalDetails?.loanID ??
      null
    );
  };

  /**
   * Current values for the base-details form. PaymentDetails isn't given the loan
   * header today, so this looks in the places it could plausibly arrive and
   * degrades to blank fields (blank = "leave this column alone") if it isn't
   * there. Pass `loanDetail={loanDetail}` from the parent to get real prefills.
   */
  getBaseLoanValues = () => {
    const { loanDetail, personalCardDetail } = this.props;
    const src =
      loanDetail ??
      personalCardDetail?.loanDetails ??
      personalCardDetail?.personalDetails ??
      {};

    return {
      loanAmount: src.loanAmount ?? "",
      // The loans table calls these totalAmountToCollect and loanTenure; the
      // friendlier names show up on some payloads, so both are probed.
      totalAmountToCollect:
        src.totalAmountToCollect ?? src.totalAmountToCollect ?? "",
      startDate: src.startDate
        ? moment(src.startDate).format("YYYY-MM-DD")
        : "",
      tenure: src.loanTenure ?? src.tenure ?? "",
    };
  };

  openEditChoice = () => this.setState({ editChoiceOpen: true });

  closeEditChoice = () => this.setState({ editChoiceOpen: false });

  openBaseDialog = () => {
    const values = this.getBaseLoanValues();
    this.setState({
      editChoiceOpen: false,
      baseDialogOpen: true,
      baseForm: { ...values },
      baseOriginal: { ...values },
      baseErrors: {},
      baseRecalculate: true,
    });
  };

  closeBaseDialog = () => {
    if (this.state.baseSaving) return; // don't close mid-request
    this.setState({ baseDialogOpen: false, baseErrors: {} });
  };

  handleBaseFieldChange = (key, value) => {
    this.setState((prev) => ({
      baseForm: { ...prev.baseForm, [key]: value },
      baseErrors: { ...prev.baseErrors, [key]: undefined },
    }));
  };

  validateBaseForm = () => {
    const { baseForm } = this.state;
    const errors = {};

    ["loanAmount", "totalAmountToCollect"].forEach((key) => {
      if (baseForm[key] === "") return;
      const n = Number(baseForm[key]);
      if (!Number.isFinite(n)) errors[key] = "Enter a valid amount";
      else if (n < 0) errors[key] = "Cannot be negative";
    });

    if (baseForm.tenure !== "") {
      const n = Number(baseForm.tenure);
      if (!Number.isInteger(n) || n < 1) {
        errors.tenure = "Enter a whole number, at least 1";
      }
    }

    if (
      baseForm.startDate !== "" &&
      Number.isNaN(new Date(baseForm.startDate).getTime())
    ) {
      errors.startDate = "Enter a valid date";
    }

    return errors;
  };

  /**
   * Sends only the fields the operator actually changed. Blank stays blank —
   * clearing a base value to NULL is never what's meant here, and the API drops
   * blanks too.
   */
  buildBasePayload = () => {
    const { baseForm, baseOriginal } = this.state;
    const payload = {};

    BASE_FIELD_DEFS.forEach(({ key, type }) => {
      const value = baseForm[key];
      if (value === "" || value === null || value === undefined) return;
      if (String(value) === String(baseOriginal[key] ?? "")) return;
      payload[key] = type === "number" ? Number(value) : value;
    });

    return payload;
  };

  handleBaseSave = async () => {
    const errors = this.validateBaseForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ baseErrors: errors });
      return;
    }

    const loanId = this.getLoanId();
    if (!loanId) {
      toast.error("Could not work out which loan to update.", TOAST_OPTS);
      return;
    }

    const fields = this.buildBasePayload();
    if (Object.keys(fields).length === 0) {
      toast.info("No changes to update.", TOAST_OPTS);
      this.setState({ baseDialogOpen: false });
      return;
    }

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + getSecureItem("token"),
    };

    // The regenerated collection rows need companyId / userId to satisfy the
    // table's NOT NULL columns. The API prefers whatever the token middleware
    // put on req.user and only falls back to these, so sending them is harmless
    // and keeps the endpoint working on servers that don't decode the token.
    const sessionUser = getSecureItem("loggedinUser") || {};
    const provenance = {};
    const sessionUserId =
      sessionUser.userId ?? sessionUser.id ?? sessionUser.loggedinUserId ?? null;
    const sessionCompanyId = getSecureItem("loggedinUserCompany") ?? null;

    if (sessionUserId !== null && sessionUserId !== undefined && sessionUserId !== "") {
      provenance.userId = sessionUserId;
    }
    if (
      sessionCompanyId !== null &&
      sessionCompanyId !== undefined &&
      sessionCompanyId !== ""
    ) {
      provenance.companyId = sessionCompanyId;
    }

    try {
      this.setState({ baseSaving: true });

      const resp = await axios.put(
        BaseUrl + '/loanCollection/editLoanBaseDetails',
        {
          loanId,
          ...fields,
          ...provenance,
          // The API defaults this to true; sending it explicitly keeps the
          // checkbox in the dialog honest.
          recalculateSchedule: this.state.baseRecalculate,
        },
        { headers },
      );

      // The API answers { status: false } for validation problems on a 200-ish
      // envelope, so check the flag rather than only the HTTP code.
      if (resp.data?.status === false) {
        toast.error(resp.data?.message || "Please fill correct data!", TOAST_OPTS);
        return;
      }

      // The recalculation summary is worth showing — it says how many rows were
      // rewritten and how many collected rows were left alone.
      const recalc = resp.data?.recalculation;
      const detail = recalc
        ? ` ${recalc.pendingRowsWritten} pending instalment(s) of ${recalc.installment} recalculated${
            recalc.keptCollectedRows > 0
              ? `, ${recalc.keptCollectedRows} collected row(s) untouched`
              : ""
          }.`
        : "";

      toast.success(
        (resp.data?.message || "Base loan details updated successfully") + detail,
        TOAST_OPTS,
      );

      this.setState({ baseDialogOpen: false });

      const { action } = this.props;
      if (action) action(loanId);
    } catch (error) {
      console.log({ error });
      toast.error(
        error?.response?.data?.message || "Please try again later!!",
        TOAST_OPTS,
      );
    } finally {
      this.setState({ baseSaving: false });
    }
  };

  splitStringToNotes(longString) {
    const maxLen = 200; // max chars per value
    const maxPairs = 15;
    const notes = {};

    // Split the long string into 256-char chunks
    const chunks = longString.match(new RegExp(`.{1,${maxLen}}`, 'g'));

    // Keep only up to 15 chunks
    chunks.slice(0, maxPairs).forEach((chunk, index) => {
      notes[`note_${index + 1}`] = chunk;
    });

    return notes;
  }

  getMainURL = () => {
    const { method } = this.props;

    const normalizedMethod = (method || "").toLowerCase().trim();

    if (normalizedMethod === "interestonly") {
      return "/loanCollection/putBalloonLoanCollection";
    }

    if (normalizedMethod === "emi method" || normalizedMethod === "emi") {
      return "/loanCollection/putLoanCollectionEMI";
    }

    if (normalizedMethod === "flexi emi") {
      return "/loanCollection/putLoanCollectionFEMI";
    }

    return `/loanCollection/putLoanCollection`;
  };

  GeneratePaymentLink = async (loanId) => {
    try {
      const user = getSecureItem("loggedinUser");
      const isIndia = getSecureItem("country")?.code == 91 ? true : false;
      const authToken = getSecureItem("token");
      // const companyId = getSecureItem("loggedinUserCompany");

      // const { data } = await axios.get(`${BaseUrl}/company/getCompanyProfile`, {
      //   params: { companyId },
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${authToken}`,
      //   },
      // });

      const res = await axios.get(`${BaseUrl}/loan/getRecordPayment`, {
        params: { loanId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const collection = res.data?.loanCollections?.[0];
      const accessToken = this.state?.accessToken;
      const notes = this.splitStringToNotes(authToken);

      if (collection?.loanCollectionId) {
        const payload = {
          accessToken,
          amount: Number(collection.collectionAmount + '00'),
          currency: isIndia ? 'INR' : 'USD',
          accept_partial: false,
          description: `Test`,
          customer: {
            name: user?.firstName + ' ' + user?.lastName,
            contact: user?.userPhone,
            email: user?.userEmail,
          },
          notify: {
            sms: true,
            email: true,
          },
          notes: {
            loanCollectionId: collection?.loanCollectionId,
            amount: Number(collection.collectionAmount + '00'),
            paymentType: "FULL",
            ...notes,
            mainURL: this.getMainURL(),
          }
        };

        let paymentLinkURL = null;

        // ---------------------------
        // CASE 1: Already has paymentLinkId → Try reusing it
        // ---------------------------
        if (collection?.paymentLinkId) {
          const res = await axios.get(
            `${ImageBaseUrl}api/razorPay/getPaymentLink?paymentLinkId=${collection.paymentLinkId}&accessToken=${this.state?.accessToken}`,
          );

          const apiAmount = Number(res?.data?.data?.amount);
          const collectionAmount = Number(collection.collectionAmount + '00');

          const isAmountMatched = apiAmount === collectionAmount;

          if (isAmountMatched) {
            paymentLinkURL = res?.data?.data?.short_url;
          } else {
            // Amount mismatch → create a new link
            const create = await axios.post(
              `${ImageBaseUrl}api/razorPay/createPaymentLink`,
              payload,
            );

            if (create?.data?.status) {
              paymentLinkURL = create?.data?.data?.short_url;
            }
          }
        } else {
          // ---------------------------
          // CASE 2: No paymentLinkId → Create new link
          // ---------------------------
          const create = await axios.post(
            `${ImageBaseUrl}api/razorPay/createPaymentLink`,
            payload,
          );

          if (create?.data?.status) {
            paymentLinkURL = create?.data?.data?.short_url;
          }
        }

        // ---------------------------
        // Share if link exists
        // ---------------------------
        window.open(paymentLinkURL, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.log('PayNow error:', JSON.stringify(error));
    }
  };

  closeRevert = () => {
    this.setState({showRevert: false});
  }

  printDocument() {
    const input = document.getElementById('divToPrint');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF("p", "mm", "a4");
        pdf.addImage(imgData, 'JPEG', 0, 0);
        // pdf.output('dataurlnewwindow');
        pdf.save("collectionreport.pdf");
      })
      ;
  }

  componentWillReceiveProps = nextProps => {
    const {
      tentureType,
      isLoanActive,
      loanHistoryDetailList,
      method,
      personalCardDetail,
      companyProfile,
      collaterals,
      fromOverDue,
    } = nextProps;
    const isInstallmentCalculator = method === "EMI Method";
    const isFlexiEMI = method === "Flexi EMI";
    const collectionMethod = method === "Collection method";
    this.setState({ collectionMethod, isFlexiEMI });
    loanHistoryDetailList.sort(function compare(a, b) {
      var dateA = new Date(a.date);
      var dateB = new Date(b.date);
      return dateA - dateB;
    });

    const lastUpdatedCollection = [...loanHistoryDetailList]
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];

    const lastNotPaidCollection =
      lastUpdatedCollection?.collectionStatus === 'Not Paid'
        ? lastUpdatedCollection
        : null;

    const firstPendingCollection = loanHistoryDetailList.find(
      item => item.collectionStatus === null
    );

    const shouldShowPreviousCollectionModal =
      fromOverDue &&
      lastNotPaidCollection &&
      firstPendingCollection &&
      new Date(lastNotPaidCollection.dueDate) < new Date(firstPendingCollection.dueDate) &&
      !this.hasShownChoiceModal;

    if (shouldShowPreviousCollectionModal) {
      this.hasShownChoiceModal = true;
      this.props.onNotPaidCollectionFound(lastNotPaidCollection);
      this.setState({
        showCollectionChoiceModal: true,
        choiceModalType: "notPaid",
        notPaidCollection: lastNotPaidCollection,
      });
    }

    if (isInstallmentCalculator && !shouldShowPreviousCollectionModal) {
      const ordered = [...loanHistoryDetailList].sort(
        (a, b) => new Date(a.dueDate) - new Date(b.dueDate)
      );
      const firstPendingIdx = ordered.findIndex(item => item.collectionStatus == null);
      const lastCollection = firstPendingIdx > 0 ? ordered[firstPendingIdx - 1] : null;

      const isPartial =
        String(lastCollection?.paymentType || "").toUpperCase() === "PARTIAL";

      if (isPartial && this.lastPartialShownFor !== lastCollection.loanCollectionId) {
        this.lastPartialShownFor = lastCollection.loanCollectionId;
        if (this.props.onNotPaidCollectionFound) {
          this.props.onNotPaidCollectionFound(lastCollection);
        }
        this.setState({
          choiceModalType: "partial",
          notPaidCollection: lastCollection,
        });
      }
    }

    this.setState({
      tentureType,
      isLoanActive,
      loanHistoryDetailList,
      isInstallmentCalculator,
      customerName: personalCardDetail?.personalDetails?.name,
      companyName: companyProfile?.companyName,
      companyAddressCity: companyProfile?.AddressCity,
      companyAddressFlatNo: companyProfile?.AddressFlatNo,
      companyAddressLandmark: companyProfile?.AddressLandmark,
      companyAddressLine: companyProfile?.AddressLine,
      companyAddressPincode: companyProfile?.AddressPincode,
      companyAddressState: companyProfile?.AddressState,
      companyAddressStreet: companyProfile?.AddressStreet,
      companyPhone: companyProfile?.phone,
      collaterals,
    });
  }

  closeChoiceModal = () => {
    this.setState({ showCollectionChoiceModal: false });
    if (this.props.onCloseChoiceModal) this.props.onCloseChoiceModal();
  };

  getPaymentStatusClass = record => {
    return record.flag ? 'NextDue' :
      record.collectionStatus === null ? "" :
        record.collectionStatus === "Paid" ? "Paid" : "Unpaid"
  }

  getCompanyDetails = async () => {
    try {
      const authToken = getSecureItem("token");
      const companyId = getSecureItem("loggedinUserCompany");
      const { data } = await axios.get(`${BaseUrl}/company/getCompanyProfile`, {
        params: { companyId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if(data?.accessToken){
        this.setState({ accessToken: data.accessToken });
      }
    } catch (error) {
      console.log({error});
    }
  }

  componentDidMount() {
    this.getCompanyDetails();
    this.setState({
      originalData: this.props.loanHistoryDetailList,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loanHistoryDetailList !== this.props.loanHistoryDetailList) {
      this.setState({
        originalData: this.props.loanHistoryDetailList,
      });
    }
    if (prevProps.notPaidCollection && !this.props.notPaidCollection) {
      this.setState({ showCollectionChoiceModal: false });
    }
  }

  handleChange = (id, field, value) => {
      this.setState(prevState => ({
        changes: {
          ...prevState.changes,
          [id]: {
            ...prevState.changes[id],
            [field]: value
          }
        }
      }));
    };

  handleValueChange = (id, field, value) => {
    const { originalData, hasShownModalForField } = this.state;

    const originalRecord = originalData.find((r) => r.loanCollectionId === id);
    if (!originalRecord) return;

    let message = "";

    // Only run when actual change happens
    if (originalRecord[field] !== value) {
      if (field === "collectionStatus") {
        if (value === "Not Paid") {
          message =
            "If you mark this as Not Paid, please reset the amount to 0 and adjust the balances accordingly.";
        } else if (value === "Paid") {
          message =
            "If you mark this as Paid, please enter the Collection Amount you want to collect.";
        }
      }
      else if (field === "collectionAmount") {
        // 🆕 Only show once per edit session
        if (!hasShownModalForField["collectionAmount"]) {
          message =
            "Update opening & closing balances, and next record’s opening balance.";
          this.setState({
            hasShownModalForField: { ...hasShownModalForField, collectionAmount: true },
          });
        }
      }

      else if (field === "PenaltyApplied") {
        // 🆕 Only show once per edit session
        if (!hasShownModalForField["PenaltyApplied"]) {
          message =
            "After adding a penalty, include the penalty amount in the next record’s collection amount to reflect it in the next collection.";
          this.setState({
            hasShownModalForField: { ...hasShownModalForField, PenaltyApplied: true },
          });
        }
      }
    }

    this.handleChange(id, field, value);

    if (message) {
      this.setState({ modalOpen: true, modalMessage: message });
    }
  };

  closeModal = () => {
    this.setState({ modalOpen: false, modalMessage: "" });
  };

  convertNumberToWords = (num) => {
    if (!num) return "Zero";
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const inWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + inWords(n % 100) : "")
        );
      if (n < 100000)
        return (
          inWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + inWords(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          inWords(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + inWords(n % 100000) : "")
        );
      return num;
    };
    return inWords(parseInt(num));
  };

  handlePrintPreview = (record) => {
    this.setState({
      selectedRecord: record,
      printModalOpen: true,
    });
  };

  handlePrint = () => {
    const printContent = document.getElementById("printableArea");
    const WinPrint = window.open("", "", "width=800,height=700");
    WinPrint.document.write("<html><head><title>Loan Receipt</title>");
    WinPrint.document.write("<style>");
    WinPrint.document.write(`
      @media print {
            .no-print { display: none !important; }
          }
      body { font-family: Arial, sans-serif; padding: 20px; }
      .receipt-container {
        border: 1px solid #000;
        padding: 20px;
        width: 500px;
        margin: auto;
      }
      .header {
        text-align: center;
        font-weight: bold;
      }
      .sub-header {
        text-align: center;
        font-size: 12px;
        margin-bottom: 10px;
      }
      table { width: 100%; font-size: 14px; border-collapse: collapse; }
      td { padding: 4px 6px; vertical-align: top; }
      .section-title { text-align: center; text-decoration: underline; margin: 10px 0; }
      .amount-box { border: 1px solid #000; text-align: right; padding: 8px; font-weight: bold; font-size: 18px; }
      hr { border: none; border-top: 1px solid #000; margin: 10px 0; }
      .footer { text-align: center; font-size: 12px; margin-top: 10px; }
    `);
    WinPrint.document.write("</style></head><body>");
    WinPrint.document.write(printContent.innerHTML);
    WinPrint.document.write("</body></html>");
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  changePaymentProcessStatus = (value) => {
    if (value === 'pay' || value === 'notpay') {
      this.setState({ isPayProcessOpen: true, paymentAction: value });
    }
    else this.setState({ isPayProcessOpen: false, paymentAction: null });
  }

  onPaymentBtnClk = async (nextDue, loanID) => {
      const { action, method, personalCardDetail } = this.props;

      const result = await fetchAPIData("paymentAction", {
          nextDue,
          name: personalCardDetail?.personalDetails.name,
          mobNo: personalCardDetail?.personalDetails.phoneNo,
          loanID,
          method,
      });
    this.setState({
      updatePreviousCollection: false,
      notPaidCollection: null,
    });
    this.props.onPaymentDone();
      action(loanID);
  };

  render() {
    const { tentureType, collectionMethod, loanHistoryDetailList,isInstallmentCalculator, isFlexiEMI, showRevert, isEditing, modalOpen, modalMessage, isPayProcessOpen, paymentAction, receivePaymentType, accessToken, collaterals } = this.state
    const currency = getSecureItem("country")?.symbol;
    const userPermissions = getSecureItem("UsersAccess");
    const firstNotPaidData = loanHistoryDetailList?.filter((data) => data?.collectionStatus === null);

    const baseButtonStyle = {
      border: "none",
      color: "white",
      borderRadius: "5px",
      cursor: "pointer",
      display: "inline-block",
      textAlign: "center",
      marginBottom: "10px",
      fontSize: "12px",
    };

    // Green button
    const successButtonStyle = {
      ...baseButtonStyle,
      backgroundColor: "#00d95e",
      padding: "10px 25px",
      marginRight: "10px"
    };

    // Red button
    const dangerButtonStyle = {
      ...baseButtonStyle,
      backgroundColor: "#c10707",
      padding: "10px 50px",
    };

    function getObjectWithFlag(array) {
      for (let i = 1; i < array.length; i++) {
        if (array[i].flag === true) {
          return array[i - 1];
        }
      }
      const lastPaid = [...array]
        .reverse()
        .find(item => item.collectionStatus === "Paid");

      return lastPaid || null;
    }

    let revertableData = getObjectWithFlag(loanHistoryDetailList);

    const revertLoan = async () => {
      if(revertableData?.paymentType == "PREPAYMENT"){
        this.setState({showRevert: false});
        toast.error("Pre/Over Payment Transactions cannot be reverted!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      } else {
      let payloadData = {
        loanCollectionId: revertableData?.loanCollectionId,
        loanId: revertableData?.loanId
      }
        
      const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ getSecureItem("token")
      }
  
        await axios
          .put(
            isInstallmentCalculator
              ? BaseUrl + "/loanCollection/revertLoanCollectionEMI"
              : isFlexiEMI
                ? BaseUrl + "/loanCollection/revertLoanCollectionFlexiEMI"
                : collectionMethod
                  ? BaseUrl + "/loanCollection/revertLoanCollection"
                  : BaseUrl + "/loanCollection/revertLoanCollectionBalloon",
            payloadData,
            {
              headers: headers,
            },
          ).then(resp => {
          if(resp.status===200) {
            toast.success("Loan Reverted Successfully!", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            });
            this.setState({showRevert: false});
            const { action } = this.props
            action(revertableData?.loanId);
          }else{
            toast.error("Please fill correct data!", {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            });
          }
      }).catch(err => {
          if(err.request.status!==200){
          toast.error("Please try again later!!", {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              });
          }
      })
    }
    }

    const handleEdit = () => {
      this.setState({
        isEditing: true,
        changes: {},
        editChoiceOpen: false,
      })
    };

    const handleSave = async () => {
      try {
        const payload = Object.entries(this.state.changes).map(([id, fields]) => ({
        loanCollectionId: id,
        ...fields,
        }));

        // console.log("Payload to API:", payload);
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+ getSecureItem("token")
        }
    
        const resp = await axios.put(BaseUrl + '/loanCollection/editLoanCollection', payload, {
            headers: headers,
        })

        // console.log("fff", resp.data);
        if(resp.status===200) {
          this.setState({ hasShownModalForField: {} }); // ✅ reset once submitted
          toast.success(resp.data?.message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });

          const { action } = this.props
          action(revertableData?.loanId);
        }
        
        this.setState({
          isEditing: false,
          changes: {}
        })
      } catch (error) {
        console.log({error});
      }
    };

    const handleCancel = () => {
      this.setState({
        isEditing: false,
        changes: {}
      })
    };

    const collateralFields = {
      "Automobiles": ["vehicleMake", "vehicleModel", "vehicleNumber"],
      "Electronic Items": ["make", "model"],
      "Insurance Policies": ["policyNumber", "expireDate"],
      "Investments": ["depositReceiptNumber", "maturityDate"],
      "Machinery and Equipment": ["make", "model", "age", "condition"],
      "Valuables and Collectibles": ["gram", "valuableType"],
      "Real Estate": ["propertyLocation", "surveyNumber"],
    };

    const { editChoiceOpen, baseDialogOpen, baseForm, baseErrors, baseSaving, baseRecalculate } = this.state;

    return (
      <div className="paymentdetailspage">

        <Dialog open={showRevert} className="dialogbox" style={{borderRadius:'5px'}}>
          <DialogTitle id="customized-dialog-title" className="TitleDiv">
            <p style={{fontFamily: "Lato"}}>All loan collection changes will be reverted. Do you want to proceed?</p>
          </DialogTitle>
            <DialogContent className="bottomPart">
                <div align="right">
                    <button style={{cursor: "pointer", padding: 10, fontSize: "15px", background: "white", border: "1px solid lightgray", borderRadius: "5px", fontFamily: "Lato", color: "#000"}} onClick={this.closeRevert}>
                      Cancel
                    </button>
                    <button style={{cursor: "pointer", padding: 10, fontSize: "15px", background: "#00d95e", color: "#fff", border: "none", borderRadius: "5px", fontFamily: "Lato", marginLeft: 10}} onClick={revertLoan}>
                      Revert
                    </button>
                </div>
            </DialogContent>
        </Dialog>

        <div className="tableTitle" >
          <div className="titleDiv">
            <h3 className="title">Loan Schedule</h3><span className="titleText">{`${loanHistoryDetailList.length} ${tentureType}`}</span>
          </div>
          {userPermissions?.editLoan && <div align="right">
            {this.state.isEditing ? (
              <div className="PaymentLayout Fonts">
                <button
                  onClick={handleSave}
                  style={successButtonStyle}
                  className="Fonts">
                  Save
                </button>
                <button
                  onClick={handleCancel}
                  style={dangerButtonStyle}
                  className="Fonts">
                  Cancel
                </button>
              </div>
            ) : (

              // The pencil no longer jumps straight into the row editor — it asks
              // which half of the loan is being corrected.
              <Tooltip title="Edit Loan">
                <IconButton
                  aria-label="edit"
                  color="primary"
                  size="medium"
                  onClick={this.openEditChoice}
                  disabled={!this.state?.isLoanActive}
                >
                  <EditOutlined fontSize="inherit" />
                </IconButton>
              </Tooltip>
            )}
          </div>}
          {/* <div className="collectionExportDiv Fonts btnSizeFont">
            <h6>
              Export to:
              </h6>
            <img src={pdf} alt="pdf" className="pdficon" onClick={this.printDocument.bind(this)} />&nbsp;&nbsp;&nbsp;
              <div style={{ margin: "auto" }}>
              <Workbook filename="collectionreport.xlsx" element={<img src={excel} alt="excel" className="excelicon" />}>
                <Workbook.Sheet data={loanHistoryDetailList} columsWidths={columnWidths} name="Collection Report Details">
                  <Workbook.Column label="Borrower Name" value="customerName" />
                  <Workbook.Column label="Loan ID" value="loanId" />
                  <Workbook.Column label="Collection Agent" value="collectionAgent" />
                  <Workbook.Column label="Total Amount" value="totalAmount" />
                  <Workbook.Column label="Installment" value="installment" />
                  <Workbook.Column label="Collected Amount" value="collectedAmount" />
                  <Workbook.Column label="Due Date" value="dueDate" />
                  <Workbook.Column label="Collected Sequence" value="collectionSeq" />
                  <Workbook.Column label="Penalty" value="Penalty" />
                </Workbook.Sheet>
              </Workbook>
            </div>
            &nbsp;&nbsp;&nbsp;
            </div> */}

        </div>

        {/* ---------- Which half of the loan are we editing? ---------- */}
        <Dialog
          open={editChoiceOpen}
          onClose={this.closeEditChoice}
          className="dialogbox"
          maxWidth="xs"
          fullWidth
        >

          <DialogTitle className="TitleDiv">
            <p className="Fonts" style={{ fontFamily: "Lato", fontSize: "16px", color: "#000", margin: 0 }}>
              What do you want to update?
            </p>
          </DialogTitle>
          <DialogContent className="bottomPart">
            <p className="Fonts" style={{ fontSize: "13px", color: "#555", marginTop: 0 }}>
              Base loan details are the sanctioned amount, total repayable amount,
              start date and tenure — changing them rebuilds the pending
              instalments. The loan schedule is the row-by-row collection plan
              below, edited one cell at a time.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, paddingBottom: 10 }}>
              <button
                className="Fonts"
                style={secondaryDialogButton}
                onClick={this.openBaseDialog}
                disabled={false}
              >
                Update Base Loan Details
              </button> 
              <button
                className="Fonts"
                style={primaryDialogButton}
                onClick={handleEdit}
              >
                Update Loan Schedule
              </button>
              <button
                className="Fonts"
                style={plainDialogButton}
                onClick={this.closeEditChoice}
              >
                Cancel
              </button>
            </div>
          </DialogContent>
        </Dialog>

        {/* ---------- Base loan details ---------- */}
        <Dialog
          open={baseDialogOpen}
          onClose={this.closeBaseDialog}
          className="dialogbox"
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle className="TitleDiv">
            <p className="Fonts" style={{ fontFamily: "Lato", fontSize: "16px", color: "#000", margin: 0 }}>
              Update Base Loan Details
            </p>
          </DialogTitle>

          <DialogContent className="bottomPart">
                       

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                gap: 16,
                paddingBottom: 8,
              }}
            >
              {BASE_FIELD_DEFS.map(({ key, label, type }) => (
                <TextField
                  key={key}
                  type={type}
                  label={
                    key === "tenure" && tentureType
                      ? `Tenure (${tentureType})`
                      : label
                  }
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={baseForm[key]}
                  onChange={(e) => this.handleBaseFieldChange(key, e.target.value)}
                  error={Boolean(baseErrors[key])}
                  helperText={baseErrors[key] || " "}
                  disabled={baseSaving}
                  InputLabelProps={type === "date" ? { shrink: true } : undefined}
                  inputProps={type === "number" ? { min: 0 } : undefined}
                />
              ))}
            </div>

            <label
              className="Fonts"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: "13px",
                color: "#555",
                cursor: baseSaving ? "default" : "pointer",
                paddingBottom: 12,
              }}
            >
              <input
                type="checkbox"
                checked={baseRecalculate}
                disabled={baseSaving}
                onChange={(e) =>
                  this.setState({ baseRecalculate: e.target.checked })
                }
              />
              Recalculate the pending instalments from these values
            </label>

            <div align="right" style={{ paddingBottom: 10 }}>
              <button
                className="Fonts"
                style={plainDialogButton}
                onClick={this.closeBaseDialog}
                disabled={baseSaving}
              >
                Cancel
              </button>
              <button
                className="Fonts"
                style={{ ...primaryDialogButton, marginLeft: 10, opacity: baseSaving ? 0.6 : 1 }}
                onClick={this.handleBaseSave}
                disabled={baseSaving}
              >
                {baseSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </DialogContent>
        </Dialog>

        <Card>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <Table className="table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    {tentureType.charAt(0)?.toUpperCase() +
                      tentureType.slice(1)?.toLowerCase()}
                  </TableCell>
                  <TableCell>Due Date</TableCell>
                  <TableCell>Opening Balance</TableCell>
                  <TableCell>Installment Amt.</TableCell>
                  {(isInstallmentCalculator || isFlexiEMI) && <TableCell>Principal</TableCell>}
                  {(isInstallmentCalculator || isFlexiEMI) && <TableCell>Interest</TableCell>}
                  <TableCell>Collection Amt</TableCell>
                  <TableCell>Collected Date</TableCell>
                  <TableCell>Collection Status</TableCell>
                  <TableCell>Closing Balance</TableCell>
                  <TableCell>Penalty</TableCell>
                  {/* {this.props.method !== 'interestOnly' && <TableCell className="tablHeadCellPayment">Actions</TableCell>} */}
                </TableRow>
              </TableHead>

              <TableBody>
                {loanHistoryDetailList.map((record, index) => (
                  <TableRow
                    key={record.loanCollectionId}
                    onClick={() => this.setState({ selectedIndex: index })}
                    className={this.state.selectedIndex === index ? "selected-row" : ""}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Index */}
                    <TableCell>{index + 1}</TableCell>

                    {/* Due Date */}
                    <TableCell>
                      {isEditing ? (
                        <TextField
                          type="date"
                          defaultValue={moment(record.dueDate).format("YYYY-MM-DD")}
                          onChange={(e) =>
                            this.handleValueChange(record.loanCollectionId, "dueDate", e.target.value)
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      ) : (
                        moment(record.dueDate).format("DD/MM/YYYY")
                      )}
                    </TableCell>

                    {/* Opening Balance */}
                    <TableCell>
                      {isEditing ? (
                        <TextField
                          type="number"
                          defaultValue={record.openingBalance}
                          onChange={(e) =>
                            this.handleValueChange(record.loanCollectionId, "openingBalance", e.target.value)
                          }
                        />
                      ) : (
                        record.openingBalance
                      )}
                    </TableCell>

                    {/* Installment */}
                    <TableCell>{record.Installment}</TableCell>

                    {/* Principal */}
                    {(isInstallmentCalculator || isFlexiEMI) && (
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            type="number"
                            defaultValue={record.principal}
                            onChange={(e) =>
                              this.handleValueChange(record.loanCollectionId, "principal", e.target.value)
                            }
                          />
                        ) : (
                          record.principal
                        )}
                      </TableCell>
                    )}

                    {/* Interest */}
                    {(isInstallmentCalculator || isFlexiEMI) && (
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            type="number"
                            defaultValue={record.interest}
                            onChange={(e) =>
                              this.handleValueChange(record.loanCollectionId, "interest", e.target.value)
                            }
                          />
                        ) : (
                          record.interest
                        )}
                      </TableCell>
                    )}

                    {/* Collection Amount */}
                    <TableCell
                      className={`${this.getPaymentStatusClass(
                        record
                      )}`}
                    >
                      {isEditing ? (
                        <TextField
                          type="number"
                          defaultValue={record.collectionAmount}
                          onChange={(e) =>
                            this.handleValueChange(
                              record.loanCollectionId,
                              "collectionAmount",
                              e.target.value
                            )
                          }
                        />
                      ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <div>
                              {record.collectionAmount}
                              </div>
                              <div>
                              {record.collectionStatus && (
                                <div>
                                  <img
                                    src={
                                      record.collectionStatus === "Paid"
                                        ? greentick
                                        : redcross
                                    }
                                    alt="tick"
                                  />
                                  {record.collectionStatus === "Not Paid" && (
                                    <div className="tooltip">
                                      {record.additionalComments}
                                    </div>
                                  )}
                                </div>
                              )}
                              </div>
                          </div>
                        
                      )}
                    </TableCell>

                    {/* Collected Date */}
                    <TableCell>
                      {userPermissions?.editCollectedDate && record.collectedDate && isEditing ? (
                        <TextField
                          type="date"
                          defaultValue={
                            record.collectedDate
                              ? moment(record.collectedDate).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) =>
                            this.handleValueChange(
                              record.loanCollectionId,
                              "collectedDate",
                              e.target.value
                            )
                          }
                        />
                      ) : record.collectedDate ? (
                        moment(record.collectedDate).format("DD/MM/YYYY")
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    {/* Collection Status */}
                    <TableCell>
                      {record.collectionStatus && isEditing ? (
                        <FormControl size="small" style={{ width: "120px" }}>
                          <Select
                            value={record.collectionStatus}
                            onChange={(e) =>
                              this.handleValueChange(
                                record.loanCollectionId,
                                "collectionStatus",
                                e.target.value
                              )
                            }
                          >
                            <MenuItem value="Paid">Paid</MenuItem>
                            <MenuItem value="Not Paid">Not Paid</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        record.collectionStatus || "-"
                      )}
                    </TableCell>

                    {/* Closing Balance */}
                    <TableCell>
                      {isEditing ? (
                        <TextField
                          type="number"
                          defaultValue={record.closingBalance}
                          onChange={(e) =>
                            this.handleValueChange(
                              record.loanCollectionId,
                              "closingBalance",
                              e.target.value
                            )
                          }
                        />
                      ) : (
                        record.closingBalance
                      )}
                    </TableCell>

                    {/* Penalty */}
                    {(
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            type="number"
                            defaultValue={record.PenaltyApplied || ""}
                            onChange={(e) =>
                              this.handleValueChange(
                                record.loanCollectionId,
                                "PenaltyApplied",
                                e.target.value
                              )
                            }
                          />
                        ) : (
                          record.PenaltyApplied || "-"
                        )}
                      </TableCell>
                    )}

                   {/* this.props.method !== "interestOnly" &&
                      //userPermissions?.revertPayment && ( */}
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                            }}
                          > 
                            {userPermissions?.revertPayment && (<div>
                              {record?.loanCollectionId === revertableData?.loanCollectionId && (
                                <a
                                  style={{
                                    color: "#4d66f0",
                                    cursor: "pointer",
                                    marginRight: "8px",
                                    display: !this.state?.isLoanActive ? "none" : "block"
                                  }}
                                  onClick={() => this.openRevert(record.collectedDate)}
                                >
                                  <Tooltip title="Revert">
                                    <Undo />
                                  </Tooltip>
                                </a>
                              )}
                            </div>)}

                            <div>
                              {record.loanCollectionId === firstNotPaidData[0]?.loanCollectionId && (
                                this.props.method !== "interestOnly" ? <a
                                  style={{
                                    color: "#4d66f0",
                                    cursor: "pointer",
                                    marginRight: "8px",
                                  }}
                                  onClick={() => {
                                    if(accessToken){
                                      this.changePaymentProcessStatus('pay');
                                    } else {
                                      this.props.history.push("/partner");
                                    }
                                  }}
                                >
                                  <Tooltip title={accessToken ? "Generate Payment Link" : "Payment integration not set up"}>
                                    <img src={shareLinkIcon} width={"40px"} height={"40px"} alt='ShareLink' />
                                  </Tooltip>
                                </a> :
                                <div className='dropdownbuttonlayout'>
                                  <button style={{padding: 0, minWidth: 0}} className='dropdownButton' >
                                    <img src={shareLinkIcon} width={"40px"} height={"40px"} alt='ShareLink' />
                                  </button>
                                  <div className='hoverMenu'>
                                      {['Interest', 'Principal']?.map(item => (
                                        <Tooltip placement="left" title={accessToken ? "Generate Payment Link" : "Payment integration not set up"}>
                                        <li
                                          className='menuItem'
                                          key={item}
                                          value={item}
                                          onClick={() => {
                                            if(accessToken){
                                              this.setState({
                                                receivePaymentType: item
                                              });
                                              this.changePaymentProcessStatus('pay');
                                            } else {
                                              this.props.history.push("/partner");
                                            }
                                          }}
                                        >
                                          Receive {item}
                                        </li>
                                        </Tooltip>
                                      ))}
                                  </div>
                                </div>
                              )}
                            </div>

                            <div>
                              {record.collectionStatus === "Paid" && (
                                <Tooltip title="Print Receipt">
                                  <button
                                    onClick={() => {
                                      this.setState({ selectedIndex: index });
                                      this.handlePrintPreview(record);
                                    }}
                                    style={{
                                      color: "white",
                                      border: "none",
                                      padding: "6px 12px",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                    }}
                                  >
                                    🖨️
                                  </button>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </TableCell>
                      {/* )} */}

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </Card>

        {/* Center Modal */}
        <Modal open={modalOpen} onClose={this.closeModal}>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#fff",
              padding: "10px",
              borderRadius: "10px",
              width: "300px",
              textAlign: "center",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.3)",
            }}
          >
            <p className='Fonts' style={{ fontSize: "16px", color: "#000", marginBottom: "20px" }}>
              {modalMessage}
            </p>
            <button
              onClick={this.closeModal}
              style={successButtonStyle}
              className="Fonts">
              OK
            </button>
          </div>
        </Modal>
        <Dialog
          open={this.state.showCollectionChoiceModal || Boolean(this.props.choiceModalOpen)}
          onClose={this.closeChoiceModal}
          style={{ borderRadius: '5px' }}
        >
          <DialogTitle className="TitleDiv">
            <p style={{ fontFamily: "Lato", fontSize: "16px", color: "#000" }}>
              {this.state.choiceModalType === "partial" ? (
                <>
                  The collection dated{' '}
                  <strong>
                    {moment(this.state.notPaidCollection?.dueDate).format('DD/MM/YYYY')}
                  </strong>{' '}
                  was only <strong style={{ color: '#e69500' }}>partially paid</strong>.
                  Do you want to collect the remaining balance for that collection or record the current one?
                </>
              ) : (
                <>
                  The collection dated{' '}
                  <strong>
                    {moment(this.state.notPaidCollection?.dueDate).format('DD/MM/YYYY')}
                  </strong>{' '}
                  was marked as{' '}
                  <strong style={{ color: '#c10707' }}>Not Paid</strong>.
                  Do you want to update that collection or record for the current one?
                </>
              )}
            </p>
          </DialogTitle>
          <DialogContent className="bottomPart">
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                style={{
                  cursor: 'pointer',
                  padding: '10px 16px',
                  fontSize: '14px',
                  background: 'white',
                  border: '1px solid lightgray',
                  borderRadius: '5px',
                  fontFamily: 'Lato',
                  color: '#000',
                }}
                onClick={() => {
                  this.closeChoiceModal();
                  this.props.onUpdatePreviousCollection(false);
                  this.props.onChangePaymentProcessStatus("pay");
                }}
              >
                Current Collection
              </button>
              <button
                style={{
                  cursor: 'pointer',
                  padding: '10px 16px',
                  fontSize: '14px',
                  background: '#00d95e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  fontFamily: 'Lato',
                }}
                onClick={() => {
                  this.closeChoiceModal();
                  this.props.onUpdatePreviousCollection(true);
                  this.props.onChangePaymentProcessStatus("pay");
                }}
              >
                Previous Collection
              </button>
            </div>
          </DialogContent>
        </Dialog>
        {/* Print Receipt Modal */}
        <Modal
          open={this.state.printModalOpen}
          onClose={() => this.setState({ printModalOpen: false })}
        >
          <div
            id="printableArea"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "#f9fafb",
              padding: "40px",
              borderRadius: "16px",
              width: "600px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
              fontFamily: "'Poppins', sans-serif",
              color: "#333",
            }}
          >
            {this.state.selectedRecord && (
              <div className="receipt-container">
                <div
                  style={{
                    textAlign: "center",
                    marginBottom: "10px",
                    fontSize: "22px",
                    fontWeight: "700",
                    color: "#1f2937",
                  }}
                >
                  {this.state.companyName}
                </div>

                <div
                  style={{
                    textAlign: "center",
                    fontSize: "13px",
                    color: "#6b7280",
                    marginBottom: "4px",
                    lineHeight: "1.4",
                  }}
                >
                  {[
                    this.state.companyAddressFlatNo,
                    this.state.companyAddressStreet,
                    this.state.companyAddressLine,
                    this.state.companyAddressLandmark,
                    this.state.companyAddressCity,
                    this.state.companyAddressState,
                    this.state.companyAddressPincode,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </div>

                {this.state.companyPhone && (
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                      color: "#6b7280",
                      marginBottom: "12px",
                    }}
                  >
                    📞 {this.state.companyPhone}
                  </div>
                )}

                <hr style={{ border: "1px dashed #d1d5db", marginBottom: "12px" }} />

                <h3
                  style={{
                    textAlign: "center",
                    color: "#111827",
                    fontWeight: "600",
                    marginBottom: "20px",
                  }}
                >
                  Loan Receipt
                </h3>

                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "14px",
                  }}
                >
                  <tbody>
                    <tr>
                      <td style={{ padding: "6px 0" }}>
                        <b>Voucher printing date:</b>{" "}
                        {this.state.selectedRecord?.collectedDate
                          ? new Date(
                            this.state.selectedRecord.collectedDate
                          ).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "-"}
                      </td>
                      <td style={{ padding: "6px 0", textAlign: "right" }}>
                        <b>Loan collected date:</b>{" "}
                        {this.state.selectedRecord?.collectedDate
                          ? new Date(
                            this.state.selectedRecord.collectedDate
                          ).toLocaleDateString("en-IN", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "-"}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: "6px 0" }} colSpan="2">
                        <b>Voucher No:</b>{" "}
                        {`${this.state.selectedRecord?.loanId || "-"} / ${this.state.selectedIndex !== null
                            ? this.state.selectedIndex + 1
                            : "-"
                          }`}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: "6px 0" }} colSpan="2">
                        <b>Account Holder:</b> {this.state.customerName || "-"}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: "6px 0" }}>
                        <b>Payment Mode:</b>{" "}
                        {this.state.selectedRecord.paymentMode || "Cash A/c"}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {collaterals && collaterals.length > 0 && (
                  <>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px", fontSize: "14px" }}>
                      {collaterals.map((c) => (
                        <React.Fragment key={c.collateralId}>
                          <div><b>Collateral Type:</b> {c.type}</div>
                          {/* <div><b>Value:</b> {c.value}</div>
                          <div><b>Serial Number:</b> {c.serialNumber}</div>
                          <div><b>Register Date:</b> {moment(c.registerDate).format("DD/MM/YYYY")}</div> */}
                          {c.detailsJson && collateralFields[c.type] && collateralFields[c.type].map((field) =>
                            c.detailsJson[field] ? (
                              <div key={field}><strong>{field.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}:</strong> {c.detailsJson[field]}</div>
                            ) : null
                          )}
                          <div style={{ gridColumn: "1 / -1" }}><hr style={{ border: "1px dashed #d1d5db", margin: "4px 0" }} /></div>
                        </React.Fragment>
                      ))}
                    </div>
                  </>
                )}
                <table style={{ width: "100%", marginBottom: "12px" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "6px 0" }}>
                        <b>Due Amount</b>{" "}
                        {currency}{' '}{this.state.selectedRecord.collectionAmount || "-"}
                      </td>
                    </tr>

                    {(this.state.selectedRecord.PenaltyApplied > 0) && (
                      <tr>
                        <td style={{
                          padding: "6px 0",
                          color: "#b91c1c",
                        }}>
                          <b>Penalty to be applied in next Payment</b>{" "}
                          {currency}{' '}{this.state.selectedRecord.PenaltyApplied || "-"}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td
                        style={{
                          padding: "10px 0",
                          background: "#ecfdf5",
                          borderRadius: "8px",
                          textAlign: "center",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#065f46",
                          marginTop: "8px",
                        }}
                        colSpan="2"
                      >
                        Amount: {currency}{' '}
                        {Number(
                          this.state.selectedRecord.collectionAmount
                        ).toLocaleString()}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: "8px 0" }} colSpan="2">
                        <b>Amount in words:</b> {getSecureItem("country")?.description}{" "}
                        {this.convertNumberToWords(
                          this.state.selectedRecord.collectionAmount
                        )}{" "}
                        Only
                      </td>
                    </tr>
                  </tbody>
                </table>

                <hr style={{ border: "1px dashed #d1d5db", marginTop: "16px" }} />

                {/* <div
                  style={{
                    textAlign: "center",
                    color: "#9ca3af",
                    fontSize: "12px",
                    marginTop: "10px",
                  }}
                >
                  ** Cheques are Subject to Realisation **
                </div> */}

                <div className="no-print" style={{ textAlign: "center", marginTop: "24px" }}>
                  <button
                    onClick={this.handlePrint}
                    style={{
                      backgroundColor: "#2563eb",
                      color: "#fff",
                      border: "none",
                      padding: "10px 24px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      fontWeight: "500",
                      transition: "0.2s",
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#1d4ed8")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "#2563eb")}
                  >
                    🖨️ Print Receipt
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal>

        {/* Share Payment Link Modal */}
        <PaymentProcess
          isFromLink={true}
          isOpen={isPayProcessOpen}
          paymentAction={paymentAction}
          changePaymentProcessStatus={this.changePaymentProcessStatus}
          onPaymentBtnClk={this.onPaymentBtnClk}
          loanId={this.props.personalCardDetail?.personalDetails.loanID}
          personalDetails={this.props.personalCardDetail?.personalDetails}
          method={this.props.method}
          nextDue={{
            ...this.props.personalCardDetail?.nextDue,
            isLastDue: this.props.personalCardDetail?.isLastDue,
          }}
          receivePaymentType={receivePaymentType}
          updatePreviousCollection={this.props.updatePreviousCollection}
          notPaidCollection={this.props.notPaidCollection}
        />
      </div>
    )
  }
}
export default PaymentDetails;



